module.exports = __webpack_public_path__ + "img/blue_048.387b1c0b.png";